import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Componente LoadingModal
function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                >
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
        .loading-modal-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1050;
        }
        .loading-modal-content {
            background: white;
            padding: 20px 40px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            box-shadow: 0 0 10px rgba(0,0,0,0.25);
        }
        .conteudo-principal {
            padding-top: 100px;
        }
      `}</style>
        </div>
    );
}

function CadastroItem() {
    // Estados do formulário
    const [descricao, setDescricao] = useState("");
    const [tipoEquipamento, setTipoEquipamento] = useState("");
    
    // Estados para o carregamento e feedback
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    
    // Estados para as listas e o modal
    const [itens, setItens] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [itemParaAssociar, setItemParaAssociar] = useState(null);
    const [lojasSelecionadas, setLojasSelecionadas] = useState([]);
    
    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const permiteCadastroCheckTI= localStorage.getItem("TICADCHECKLIST");
    
    // Lista de tipos de equipamento
    const tiposDeEquipamento = [
        "DESKTOP", "CANCELA", "COLETOR", "IMPRESSORA", "TIRA-TEIMA","ROTEADOR WIFI", "SWITCH", "RAMAL", "CELULAR",
        "BALANÇA", "SOM", "TV", "PDV", "REP"
    ];

    // Hook para carregar dados iniciais (itens e lojas)
    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }else if (permiteCadastroCheckTI !== "S") {
            Swal.fire({ icon: 'error', title: 'Acesso Negado', text: 'Não é permitido acessar o cadastro de CheckList.', confirmButtonText: 'OK' })
                .then(() => navigate("/arbor/home"));
            }
        
        const carregarDados = async () => {
            try {
                setLoading(true);
                setLoadingMessage("Carregando itens e lojas...");
                
                const [lojasRes, itensRes] = await Promise.all([
                    api.get("lojas/localizacao"),
                    api.get("/checklist/itens")
                ]);
                
                const lojasPermitidas = lojasRes.data.filter(l => l.cod_emp < 50 && l.cod_emp !== 1 && l.cod_emp !== 23);
                setLojas(lojasPermitidas);
                setItens(itensRes.data);
                
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                Swal.fire('Erro', 'Não foi possível carregar os dados.', 'error');
            } finally {
                setLoading(false);
            }
        };
        
        carregarDados();
    }, [chapa, navigate]);

    // Função para lidar com o cadastro de um novo item
    const handleCadastrar = async (event) => {
        event.preventDefault(); 
        
        if (!descricao || !tipoEquipamento) {
            Swal.fire('Aviso', 'Preencha a descrição e o tipo de equipamento.', 'warning');
            return;
        }

        try {
            setLoading(true);
            setLoadingMessage("Cadastrando item de checklist...");

            const response = await api.post('/checklist/item', {
                descricao: descricao,
                tipoEquipamento: tipoEquipamento,
            });

            // Usar o nome da propriedade exato que a API retorna
            const novoItem = { id_item: response.data.id_item, descricao, tipo_equipamento: tipoEquipamento };
            
            Swal.fire('Sucesso!', `Item cadastrado com sucesso! ID: ${novoItem.id_item}`, 'success');
            
            // Adiciona o novo item à lista sem recarregar tudo
            setItens([novoItem, ...itens]);
            setDescricao("");
            setTipoEquipamento("");

        } catch (error) {
            console.error("Erro no cadastro:", error);
            const errorMessage = error.response?.data?.erro || "Ocorreu um erro ao processar a requisição.";
            Swal.fire('Erro', errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };
    
    // Abre o modal de associação
    const handleAbrirModal = async (item) => {
        setItemParaAssociar(item);
        
        // Carrega as associações atuais do item
        try {
            setLoading(true);
            setLoadingMessage("Buscando associações atuais...");
            // Usar a propriedade 'id_item' aqui
            const res = await api.get(`/checklist/item/${item.id_item}/lojas`);
            setLojasSelecionadas(res.data.map(loja => String(loja.id_loja))); // Assumindo que a API retorna 'id_loja'
        } catch (error) {
             if (error.response?.status === 404) {
                 setLojasSelecionadas([]);
             } else {
                 console.error("Erro ao carregar associações:", error);
                 Swal.fire('Erro', 'Não foi possível carregar as associações atuais do item.', 'error');
             }
        } finally {
            setLoading(false);
            setShowModal(true);
        }
    };

    const handleFecharModal = () => {
        setShowModal(false);
        setLojasSelecionadas([]);
        setItemParaAssociar(null);
    };

    // Lida com a seleção/desseleção de checkboxes no modal
    const handleLojaChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setLojasSelecionadas([...lojasSelecionadas, value]);
        } else {
            setLojasSelecionadas(lojasSelecionadas.filter(id => id !== value));
        }
    };
    
    // Nova função para marcar todas as lojas
    const handleMarcarTodas = () => {
        const todosCodEmp = lojas.map(loja => String(loja.cod_emp));
        setLojasSelecionadas(todosCodEmp);
    };

    // Nova função para desmarcar todas as lojas
    const handleDesmarcarTodas = () => {
        setLojasSelecionadas([]);
    };

    // Salva as associações do modal
    const handleSalvarAssociacoes = async () => {
        if (!itemParaAssociar) return;
        
        try {
            setLoading(true);
            setLoadingMessage("Salvando associações...");

            // Lógica para comparar e salvar:
            // 1. Busca associações atuais do item
            let associacoesAtuais = [];
            try {
                // Usar a propriedade 'id_item'
                const res = await api.get(`/checklist/item/${itemParaAssociar.id_item}/lojas`);
                associacoesAtuais = res.data.map(loja => String(loja.id_loja)); // Assumindo 'id_loja'
            } catch (e) { /* Ignora 404 */ }
            
            const paraAdicionar = lojasSelecionadas.filter(id => !associacoesAtuais.includes(id));
            const paraRemover = associacoesAtuais.filter(id => !lojasSelecionadas.includes(id));

            const promises = [];
            
            for (const idLoja of paraAdicionar) {
                // Enviar os dados no formato esperado pela API
                promises.push(api.post('/checklist/vincularitem', { loja: parseInt(idLoja), item: itemParaAssociar.id_item }));
            }
            
            for (const idLoja of paraRemover) {
                // Enviar os dados no formato esperado pela API
                promises.push(api.delete(`/checklist/desvincularitem/${idLoja}/${itemParaAssociar.id_item}`));
            }

            if (promises.length > 0) {
                await Promise.all(promises);
                Swal.fire('Sucesso!', 'Associações salvas com sucesso.', 'success');
            } else {
                Swal.fire('Aviso', 'Nenhuma alteração a ser salva.', 'info');
            }
            
        } catch (error) {
            console.error("Erro ao salvar associações:", error);
            Swal.fire('Erro', 'Ocorreu um erro ao salvar as associações.', 'error');
        } finally {
            setLoading(false);
            handleFecharModal();
        }
    };
    
    return (
        <div className="d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />
            <div className="container-fluid flex-grow-1 conteudo-principal">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h4 className="mt-4">Cadastrar e Gerenciar Itens de Checklist</h4>

                        {/* Formulário de Cadastro */}
                        <form onSubmit={handleCadastrar} className="mb-5">
                            <div className="row g-2">
                                {/* Campo Descrição */}
                                <div className="col-md-5">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Descrição do Item"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)}
                                        required
                                    />
                                </div>
                                {/* Combo de Tipo de Equipamento */}
                                <div className="col-md-3">
                                    <select
                                        className="form-select"
                                        value={tipoEquipamento}
                                        onChange={e => setTipoEquipamento(e.target.value)}
                                        required
                                    >
                                        <option value="">Selecione o Tipo</option>
                                        {tiposDeEquipamento.map(tipo => (
                                            <option key={tipo} value={tipo}>
                                                {tipo}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* Botão de Cadastro */}
                                <div className="col-md-2">
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                        disabled={loading}
                                    >
                                        Cadastrar
                                    </button>
                                </div>
                            </div>
                        </form>

                        {/* Lista de Itens Cadastrados */}
                        <h5 className="mb-3">Itens Cadastrados</h5>
                        <div className="list-group">
                            {itens.length > 0 ? (
                                itens.map(item => (
                                    <li key={item.id_item} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div className="me-auto">
                                            <div>**{item.descricao}**</div>
                                            <div className="text-muted small">{item.tipo_equipamento}</div>
                                        </div>
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => handleAbrirModal(item)}
                                        >
                                            Associar Lojas
                                        </button>
                                    </li>
                                ))
                            ) : (
                                <div className="text-center text-muted py-5">
                                    Nenhum item de checklist cadastrado.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de Associação */}
            <Modal show={showModal} onHide={handleFecharModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Associar Lojas a: **{itemParaAssociar?.descricao}**
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-end mb-2">
                        <Button variant="link" onClick={handleMarcarTodas} className="me-2 p-0">
                            Marcar Todas
                        </Button>
                        <Button variant="link" onClick={handleDesmarcarTodas} className="p-0">
                            Desmarcar Todas
                        </Button>
                    </div>
                    <div className="form-control" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {lojas.length > 0 ? (
                            lojas.map(loja => (
                                <div key={loja.cod_emp} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={loja.cod_emp}
                                        id={`lojaCheck-${loja.cod_emp}`}
                                        onChange={handleLojaChange}
                                        checked={lojasSelecionadas.includes(String(loja.cod_emp))}
                                    />
                                    <label className="form-check-label" htmlFor={`lojaCheck-${loja.cod_emp}`}>
                                        Loja {String(loja.cod_emp).padStart(2, '0')} - {loja.razao}
                                    </label>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted">Carregando lojas...</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleFecharModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSalvarAssociacoes} disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar Associações'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <LoadingModal show={loading} message={loadingMessage} />
            <Footer />
        </div>
    );
}

export default CadastroItem;